import { serializeFilter } from 'utils/general';

import type { SortFilterSearchState } from './useSortFilterSearch';

export const queryStringBuilder = (sfsState?: SortFilterSearchState): string => {
  let query: string = '';

  if (sfsState?.search?.length) {
    query = `?q=${sfsState?.search}`;
  }

  if (sfsState?.sortFilter?.sort && Object.keys(sfsState?.sortFilter?.sort).length) {
    if (query.length > 1) {
      query += `&sortKey=${sfsState?.sortFilter?.sort.key}&sortDirection=${sfsState?.sortFilter?.sort.direction}`;
    } else {
      query = `?sortKey=${sfsState?.sortFilter?.sort.key}&sortDirection=${sfsState?.sortFilter?.sort.direction}`;
    }
  }

  if (sfsState?.sortFilter?.filters?.options?.length) {
    let q: string = ``;

    q += `filter=${serializeFilter(sfsState?.sortFilter?.filters.options)}`;

    if (query.length > 1) {
      query += `&${q}`;
    } else {
      query = `?${q}`;
    }
  }

  if (sfsState?.sortFilter?.offset) {
    const q: string = `skip=${sfsState?.sortFilter?.offset}`;

    if (query.length > 1) {
      query += `&${q}`;
    } else {
      query = `?${q}`;
    }
  }

  return query;
};

